import BaseObject from '../../../base/base_object';

export default class GameSequenceHelper extends BaseObject {
    init(params) {
        super.init(params);

        if(!params.createGameSequenceBuilderCallback) {
            this.throwArgumentExpected('8', 'init', 'createGameSequenceBuilderCallback');
        }

        this._currentSteps = params.currentSteps || [];
        this._createGameSequenceBuilderCallback = params.createGameSequenceBuilderCallback;
        this.isGameStepOrDescriptorCallback = params.isGameStepOrDescriptorCallback;
    }

    _findStepIndex(gameStepPrototype) {
        return this._currentSteps.findIndex(step => step instanceof gameStepPrototype);
    }

    _createNewGameSequenceBuilder() {
        return this._createGameSequenceBuilderCallback(this._currentSteps);
    }

    _checkIsGameStep(prototypeOrDescriptor) {
        if(!this.isGameStepOrDescriptorCallback(prototypeOrDescriptor)) {
            this.throwError('26', `Provided game step prototype ${prototypeOrDescriptor} doesn't inherit from GameStepBase and is not an instance of GameStepInstanceDescriptor either`);
        }
    }
}